/**
 * useGetDropPlaying — creators live in this title's category right now.
 *
 * COVERAGE, not endorsement. The roster hook next to this one answers "who
 * does this publisher work with"; this answers "who is playing this", which
 * anyone can join by launching the game. Keeping them as two hooks is
 * deliberate — a component that wants one must not accidentally render the
 * other's meaning.
 */

import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropPlaying(slug?: string, limit?: number) {
    return useQuery({
        queryKey: ["drop-playing", slug, limit],
        queryFn: async () => {
            if (!slug) return null;
            return new DropsApi(getConfig()).getDropsSlugSlugPlaying({
                slug,
                limit: limit ? String(limit) : undefined,
            });
        },
        enabled: Boolean(slug),
        /*
         * Same cadence as the roster — this is live data, and a category page
         * that lags by minutes shows people who already stopped.
         */
        staleTime: 30 * 1000,
        refetchInterval: 60 * 1000,
        placeholderData: keepPreviousData,
    });
}
